// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as OrdersRequestsActions } from '../duck';
import type { RootState } from '../../index';
import OrdersRequest from '../components/OrdersRequests/OrdersRequests';
import { actions as AlertActions } from '../../alert/duck';
import { actions as LocalValuesActions } from '../../../modules/local-values/duck';

function mapStateToProps(state: RootState) {
  return {
    isFetchingAvailable: state.flight.isFetchingAvailable,
    availableOrders: state.flight.availableOrders,
    page: state.flight.availableOrdersPage,
    canAsk: state.flight.availableOrdersPageCanAsk,
    fetchRequestsError: state.flight.fetchRequestsError,
    localeState: state.locale,
    localValues: state.localValues,
    //isFetchingOnlineStores: state.flight.isFetchingOnlineStores,
    //onlineStores: state.flight.onlineStores,
    //fetchOnlineStoresError: state.flight.fetchOnlineStoresError,
    flight: state.flight.flight,
    isFetchingReward: state.flight.isFetchingReward,
    travelerReward: state.flight.travelerReward,
    user: state.auth.user,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...OrdersRequestsActions,
    ...AlertActions,
    ...LocalValuesActions,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(OrdersRequest);



// WEBPACK FOOTER //
// ./src/modules/flight/containers/OrdersRequestsContainer.js